/**
 * MI-326 — state each browser tab keeps for itself, with the last one used
 * anywhere as the starting point for a new tab.
 *
 * Filters and Display settings used to live in localStorage alone, one store
 * for every tab, so two open tabs wrote over each other and the last change
 * won: leaving Movements in one tab and coming back picked up whatever the
 * other tab had chosen meanwhile. sessionStorage belongs to one tab and
 * survives its reloads, but a new tab starts with it empty — so a read tries
 * this tab's copy first and falls back to the shared one, and a write goes to
 * both.
 *
 * Values are strings, as both stores take them. Unavailable storage (private
 * mode, quota) reads as nothing and drops the write: the URL still carries the
 * state.
 */
export function readTabState(key) {
  try {
    return window.sessionStorage.getItem(key) ?? window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeTabState(key, value) {
  try {
    window.sessionStorage.setItem(key, value);
    window.localStorage.setItem(key, value);
  } catch {
    /* see above */
  }
}
